import CouponApi from '@apis/coupon/CouponApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetCouponsParams, GetDownloadableCouponsParams } from '@models/coupon';

const couponQueries = createQueryKeys('coupons', {
  list: (params: GetCouponsParams) => ({
    queryKey: ['list', params],
    queryFn: () => CouponApi.getMyCoupons(params),
  }),
  detail: (id: string) => ({
    queryKey: ['detail', id],
    queryFn: () => CouponApi.getMyCoupon(id),
  }),
  history: (params: GetCouponsParams) => ({
    queryKey: ['history', params],
    queryFn: () => CouponApi.getCouponHistories(params),
  }),
  downloadAble: (params: GetDownloadableCouponsParams) => ({
    queryKey: ['downloadAble', params],
    queryFn: () => CouponApi.getDownloadableCoupons(params),
  }),
});

export default couponQueries;
